import React from 'react';

import MicrosoftBackgroundIcon from 'components/Icons/MicrosoftBackground.png';

import makeStyles from '@material-ui/core/styles/makeStyles';

function SplitPageLeft() {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <img
        alt="images of people and cards with their work information and interests"
        data-testid="microsoft-background-icon"
        className={classes.icon}
        src={MicrosoftBackgroundIcon}
      />
    </div>
  );
}

const useStyles = makeStyles(theme => {
  return {
    container: {
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    icon: {
      width: '80%',
    },
  };
});

export default SplitPageLeft;
